import { Chip, ChipProps, styled } from "@mui/material";
import React from "react";

const DEFAULT_MAX_WIDTH = 180;

export interface PillProps extends Omit<ChipProps, "size"> {
    noWrap?: boolean;
    rounded?: boolean;
}

const StyledChip = styled(Chip, {
    shouldForwardProp: (prop) => prop !== "noWrap" && prop !== "rounded",
})<{ noWrap?: boolean; rounded?: boolean }>(({ theme, noWrap, rounded }) => ({
    fontSize: "0.6rem",
    fontWeight: 600,
    height: "18px",
    backgroundColor: "#f3f4f6", // Default greyish background
    border: "none",
    ...(noWrap && {
        maxWidth: "100%",
    }),
    ...(rounded && {
        borderRadius: "999px",
    }),
    "& .MuiChip-label": {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(0.25),
        paddingBottom: theme.spacing(0.25),
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
    },
    "& .MuiChip-icon": {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(-0.5),
        color: "inherit", // Same color as text
        flexShrink: 0,
    },
    "& .MuiChip-deleteIcon": {
        flexShrink: 0,
    },
    // Single place to control icon size
    "& svg": {
        fontSize: "0.75rem !important",
        width: "0.75rem !important",
        height: "0.75rem !important",
    },
}));

const TruncatedLabel = styled("span")({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: DEFAULT_MAX_WIDTH,
});

export const Pill: React.FC<PillProps> = ({
    noWrap,
    rounded,
    label,
    ...props
}) => {
    const wrappedLabel =
        noWrap && label ? <TruncatedLabel>{label}</TruncatedLabel> : label;

    return (
        <StyledChip
            size="small"
            noWrap={noWrap}
            rounded={rounded}
            label={wrappedLabel}
            {...props}
        />
    );
};
